import { computed, inject, Injectable } from '@angular/core';
import { IUserMenu } from 'projects/shared/src/lib/models/user-menu.model';
import { EVFunctions, IFormSchema } from 'ets-fe-ng-sdk';
import { ApiService } from 'projects/shared/src/lib/services/api.service';
import { AuthenticationService } from 'projects/shared/src/lib/authentication/authentication.service';
import { EUserType } from 'projects/shared/src/lib/@ngrx/user/user.model';
import { rxResource } from '@angular/core/rxjs-interop';
import { map, of } from 'rxjs';
import { UtilityService } from 'projects/shared/src/lib/services/utility.service';

export const PRESET_USER_MENU_OWNER = 'PRESETS';

@Injectable({
  providedIn: 'root',
})
export class UserMenuService {
  readonly authS = inject(AuthenticationService);
  readonly apiS = inject(ApiService);
  readonly uS = inject(UtilityService);

  protected readonly baseURL = `v1/users/menu/config`;

  readonly selectSchema = computed<Partial<IFormSchema>>(() => ({
    label: 'User Menu',
    type: 'autocomplete',
    optionsInitFunc2: () => this.listAll(),
    valueField: 'userMenu',
    labelField: ['userMenu', 'description'],
  }));

  readonly ownerType = computed(() => this.authS.userType() || EUserType.admin);
  readonly owner = computed(() => this.ownerType());

  readonly menuDetailsRes = rxResource({
    params: () => this.authS.user()?.userMenu,
    stream: (o) =>
      o.params
        ? this.uS.rxResourceErrorWrapper(this.apiS.get<IUserMenu>(`${this.baseURL}/${o.params}`))
        : of(null),
  });

  readonly userMenuDetails = computed(() => this.menuDetailsRes.value()?.userMenuConfigDetails || []);

  listAll = () => this.apiS.get<IUserMenu['userMenuConfig'][]>(`${this.baseURL}/desc`);

  listByOwner = (owner: string) =>
    this.apiS.get<IUserMenu['userMenuConfig'][]>(`${this.baseURL}/desc/${encodeURIComponent(owner)}`);

  getSingle = (code: string) => this.apiS.get<IUserMenu>(`${this.baseURL}/${code}`);

  getDescriptionByCode = (code: string) => {
    return this.apiS
      .get<IUserMenu>(`${this.baseURL}/${code}`)
      .pipe(map((r) => EVFunctions.strConcatenator2(code, r?.userMenuConfig?.description!)));
  };

  save = (data: IUserMenu) => this.apiS.post<IUserMenu>(this.baseURL, data);
}
